import { Link, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { getVisibleAdminMenuItems } from '../utils/adminPermissions';

const MENU_SECTIONS = [
  {
    label: 'Overview',
    items: [
      { title: 'Dashboard', path: '/admin/dashboard', icon: 'bi-speedometer2' }
    ]
  },
  {
    label: 'Content',
    items: [
      { title: 'News & Posts', path: '/admin/news', icon: 'bi-newspaper' },
      { title: 'Blogs', path: '/admin/blogs', icon: 'bi-journal-text' },
      { title: 'Events', path: '/admin/events', icon: 'bi-calendar-event' },
      { title: 'Gallery', path: '/admin/gallery', icon: 'bi-images' },
      { title: 'Projects', path: '/admin/projects', icon: 'bi-folder-check' },
      { title: 'Announcements', path: '/admin/announcements', icon: 'bi-megaphone' }
    ]
  },
  {
    label: 'Clinical',
    items: [
      { title: 'Diseases & Conditions', path: '/admin/diseases', icon: 'bi-heart-pulse' },
      { title: 'Tests & Procedures', path: '/admin/tests-procedures', icon: 'bi-clipboard2-check' },
      { title: 'Symptom browse text', path: '/admin/symptom-browse', icon: 'bi-card-text' },
      { title: 'Services', path: '/admin/services', icon: 'bi-hospital' },
      { title: 'Departments', path: '/admin/departments', icon: 'bi-building' }
    ]
  },
  {
    label: 'Organization',
    items: [
      { title: 'Senior Management', path: '/admin/senior-management', icon: 'bi-people-fill' },
      { title: 'Donors & Partners', path: '/admin/donors-partners', icon: 'bi-handshake' }
    ]
  },
  {
    label: 'System',
    items: [
      { title: 'Users', path: '/admin/users', icon: 'bi-people' },
      { title: 'Security Monitor', path: '/admin/security', icon: 'bi-shield-lock' },
      { title: 'Backups', path: '/admin/backups', icon: 'bi-cloud-arrow-up' },
      { title: 'Activity Logs', path: '/admin/activity-logs', icon: 'bi-clock-history' }
    ]
  }
];

function AdminSidebar({ onLogout, show = false, onNavigate, onClose }) {
  const location = useLocation();
  const userRole = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('user') || '{}')?.role || null;
    } catch (_e) {
      return null;
    }
  }, [location.pathname]);

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const sections = useMemo(() => {
    return MENU_SECTIONS.map((section) => ({
      ...section,
      items: getVisibleAdminMenuItems(userRole, section.items)
    })).filter((section) => section.items.length > 0);
  }, [userRole]);

  return (
    <aside className={`admin-sidebar ${show ? 'show' : ''}`} aria-label="Admin navigation">
      <div className="admin-sidebar-header">
        <div className="admin-sidebar-brand">
          <img src="/img/tghlogo.png" alt="" className="admin-sidebar-logo" />
          <div className="admin-sidebar-brand-text">
            <strong>TGH Admin</strong>
            <span>Tema General Hospital</span>
          </div>
          <button
            type="button"
            className="admin-sidebar-close"
            aria-label="Close admin menu"
            onClick={() => onClose?.()}
          >
            <i className="bi bi-x-lg" aria-hidden="true" />
          </button>
        </div>
      </div>

      <nav className="admin-sidebar-nav">
        {sections.map((section) => (
          <div key={section.label} className="admin-sidebar-section">
            <p className="admin-sidebar-section-label">{section.label}</p>
            {section.items.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`admin-sidebar-item ${isActive(item.path) ? 'active' : ''}`}
                onClick={() => onNavigate?.()}
              >
                <i className={`bi ${item.icon}`} aria-hidden="true" />
                <span>{item.title}</span>
              </Link>
            ))}
          </div>
        ))}
      </nav>

      <div className="admin-sidebar-footer">
        <Link
          to="/admin/change-password"
          className={`admin-sidebar-item ${isActive('/admin/change-password') ? 'active' : ''}`}
          onClick={() => onNavigate?.()}
        >
          <i className="bi bi-key" aria-hidden="true" />
          <span>Change Password</span>
        </Link>
        <button
          type="button"
          className="admin-sidebar-item admin-sidebar-logout"
          onClick={() => {
            onNavigate?.();
            onLogout();
          }}
        >
          <i className="bi bi-box-arrow-right" aria-hidden="true" />
          <span>Sign out</span>
        </button>
      </div>
    </aside>
  );
}

export default AdminSidebar;
